// extracted by mini-css-extract-plugin
export default {"crumb":"Breadcrumbs_crumb__00KgD","custom_hover":"Breadcrumbs_custom_hover__4jQmr"};